/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
const deps = ['Api'];
const factory = function (Api) {
  class GatewayApi extends Api {
    constructor() {
      super('gateway');
    }
  }

  return new GatewayApi();
};

factory.$inject = deps;
module.exports = factory;
